/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Flow_Step3Inputs */

const en_directory_submit_flow_step3 = /** @type {(inputs: Directory_Submit_Flow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review & choose a plan`)
};

const zh_directory_submit_flow_step3 = /** @type {(inputs: Directory_Submit_Flow_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审核并选择方案`)
};

/**
* | output |
* | --- |
* | "Review & choose a plan" |
*
* @param {Directory_Submit_Flow_Step3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_flow_step3 = /** @type {((inputs?: Directory_Submit_Flow_Step3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Flow_Step3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_flow_step3(inputs)
	return zh_directory_submit_flow_step3(inputs)
});
export { directory_submit_flow_step3 as "directory.submit.flow.step3" }